// All available plans from Fusebill
export enum PricingPlanEnum {
    mastering_basic = 'mastering_basic',
    mastering_advanced = 'mastering_advanced',
    mastering_pro = 'mastering_pro',
    distribution_tier1 = 'distribution_tier1',
    distribution_tier2 = 'distribution_tier2',
}

// All distribution plan codes
export enum DistributionPlanCodesEnum {
    distribution_freemium = 'distribution_freemium',
    distribution_tier1 = 'distribution_tier1',
    distribution_tier2 = 'distribution_tier2',
}
